import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import reveal from './directives/reveal';
import '../src/assets/css/reset.css' 
import '../src/assets/css/fonts.css' 
import '../src/assets/css/layout.css' 

createApp(App).use(router).directive('reveal', reveal).mount('#app');
